




























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import syscodedata from '@/store/entities/sm/systemcodes'
@Component
export default class CreateSystemCode extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean
  syscodedata: syscodedata = new syscodedata()
  get categorylist() {
    return this.$store.state.systemcode.categorylist
  }
  save() {
    ;(this.$refs.SystemCodeForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let reponse = await this.$store.dispatch({
          type: 'systemcode/CreateSystemCodeInfo',
          data: this.syscodedata
        })
        if (reponse.success == true) {
          this.$message({
            message: reponse.message,
            type: 'success'
          })
        }
        ;(this.$refs.SystemCodeForm as any).resetFields()
        this.$emit('save-success')
        this.$emit('input', false)
      }
    })
  }
  clear() {
    this.$emit('input', false)
  }
  cancel() {
    ;(this.$refs.SystemCodeForm as any).resetFields()
    this.$emit('input', false)
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value)
    } else {
      //加载类别数据
      this.$store.dispatch({
        type: 'systemcode/GetSystemCodeCategoryInfo'
      })
    }
  }
  SystemCodeRule = {
    code: [{ required: true, message: '请输入键值', trigger: 'blur' }],
    displayName: [{ required: true, message: '请输入标签', trigger: 'blur' }],
    category: [{ required: true, message: '请选择类型', trigger: 'change' }],
    sortNo: [{ required: true, message: '请输入排序值', trigger: 'blur' }]
  }
}
